
<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>企业基本信息</span>
    </div>
    <div class="comBaseInfo">
      <div class="comBaseInfo-header">
        <img src="../../assets/images/comp.png"/>
        <div class="editBtnCom" @click="disabled=false" v-if="disabled">编辑信息</div>
         <div class="editBtnCom" @click="onSave" v-else>保存</div>
      </div>
      <div class="comBaseInfo-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm"
          style="width: 500px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="企业名称：" prop="orgName">
            <el-input v-model="ruleForm.orgName" placeholder="请输入企业名称" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="社会统一代码：" prop="companyCode">
            <el-input v-model="ruleForm.companyCode" placeholder="请输入社会统一代码" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="所属区域" prop="orgDistrictId" style="position: relative;">
            <el-cascader ref="cascaderDis" @change="changeDis" :props="props" placeholder="请选择所属区域" v-model="ruleForm.orgDistrictId" style="width: 100%;" :disabled="disabled"></el-cascader>
             <el-input v-if="isClick" v-model="ruleForm.orgDistrictName" placeholder="请选择所属区域" :disabled="disabled" style="pointerEvents: none;position: absolute;left: 0px;"></el-input>
          </el-form-item>
          <el-form-item label="企业地址" prop="address">
            <el-input class="rg-input" placeholder="企业地址" v-model="ruleForm.address" :disabled="disabled">
            </el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input placeholder="请输入联系人" v-model="ruleForm.contact" :disabled="disabled">
            </el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="telephone">
            <el-input class="rg-input" placeholder="请输入联系方式" v-model="ruleForm.telephone" :disabled="disabled">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      var $this = this;
      return {
        rules: {
          orgName: [{
            required: true,
            message: '企业名称不能为空',
            trigger: 'blur'
          }],
          companyCode: [{
            required: true,
            message: '社会统一代码不能为空',
            trigger: 'blur'
          }],
          orgDistrictId:[{
            required: true,
            message: '所属区域不能为空',
            trigger: 'blur'
          }]
        },
        disabled:true,
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value
            } = node;
            var loadUrl = '/system/district/tree2.htm'
            if (value) {
              loadUrl += '?parentId=' + value;
            }
            $this.$axios.get(loadUrl).then(res => {
              var data = res.data;
              $this.disList=data;
              const nodes = data.map(item => ({
                value: item.id,
                label: item.text,
                leaf: !item.isParent
              }));
              resolve(nodes);
            })
          },
        },
        ruleForm: {
        },
        isClick:true,
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        districtId:'',
        disList:[]
      }
    },
    methods: {
      onSave: function() {
        var $this = this;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$set(this.ruleForm,'orgDistrictId',this.ruleForm.orgDistrictId[this.ruleForm.orgDistrictId.length-1]);
            delete this.ruleForm.superviseList;
            this.$axios.post('/system/companyinfo/save.htm', this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                if (data.stat == '1') {
                  this.$message({
                    message: '修改企业信息成功！',
                    type: 'success'
                  });
                  this.disabled=true;
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getData: function(id) {
        this.$axios.get('/system/companyinfo/load.htm?orgId=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.ruleForm = data.data;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      changeDis:function(val,a){
        this.isClick=false;
        this.$set(this.ruleForm,'orgDistrictName',this.$refs.cascaderDis.getCheckedNodes()[0].label);
      }
    },
    created: function() {
      this.getData(this.currentUser.orgId)
    }
  }
</script>
<style>
  .comBaseInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comBaseInfo-header {
    height: 122px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .editBtnCom{
    width: 97px;
    height: 44px;
    background: #ffffff;
    border: 1px solid #0071ba;
    border-radius: 23px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #0071ba;
    line-height: 44px;
    margin-left: 17px;
    cursor: pointer;
  }
  .avatar {
    width: 100px;
    height: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/CompanyInfo.vue